import state from './moduleStoreProductsState.js';
import mutations from './moduleStoreProductsMutations.js';
import actions from './moduleStoreProductsActions.js';
import getters from './moduleStoreProductsGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
